export const blockIconsActionPaid = (
	<span className='material-symbols-outlined'>paid</span>
);
